import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ThemeState {
  theme: 'light' | 'dark'
  toggleTheme: () => void
  setTheme: (theme: 'light' | 'dark') => void
}

// Read the FOUC-applied class on <html>. The inline bootstrap in index.html
// already resolved: persisted toggle > OS prefers-color-scheme. Initialising
// from the DOM keeps Zustand in lockstep with what the user is actually
// seeing, so onRehydrateStorage won't flip the class back on first paint
// when there is no persisted toggle yet.
function getInitialTheme(): 'light' | 'dark' {
  if (typeof document === 'undefined') return 'light'
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: getInitialTheme(),

      toggleTheme: () => {
        const newTheme = get().theme === 'light' ? 'dark' : 'light'
        set({ theme: newTheme })
        updateDocumentTheme(newTheme)
      },

      setTheme: (theme: 'light' | 'dark') => {
        set({ theme })
        updateDocumentTheme(theme)
      },
    }),
    {
      name: 'qkey-theme',
      onRehydrateStorage: () => (state) => {
        if (state) {
          updateDocumentTheme(state.theme)
        }
      },
    }
  )
)

function updateDocumentTheme(theme: 'light' | 'dark') {
  if (theme === 'dark') {
    document.documentElement.classList.add('dark')
    document.body.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
    document.body.classList.remove('dark')
  }
}